import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SectionHeading from "@/components/SectionHeading";
import { useLanguage } from "@/i18n/LanguageContext";

const FAQSection = ({ dark = false }: { dark?: boolean }) => {
  const { t } = useLanguage();

  const faqs = [
    { q: t("faq_q1"), a: t("faq_a1") },
    { q: t("faq_q2"), a: t("faq_a2") },
    { q: t("faq_q3"), a: t("faq_a3") },
    { q: t("faq_q4"), a: t("faq_a4") },
    { q: t("faq_q5"), a: t("faq_a5") },
    { q: t("faq_q6"), a: t("faq_a6") },
  ];

  return (
    <section className={`section-padding ${dark ? "bg-kuro" : "bg-washi"}`}>
      <SectionHeading
        subtitle={t("faq_label")}
        title={t("faq_title")}
        light={dark}
      />

      {/* FAQPage structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.q,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.a,
              },
            })),
          }),
        }}
      />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-3xl mx-auto"
      >
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className={`border ${dark ? "border-shiro/10 data-[state=open]:border-aka/30" : "border-border data-[state=open]:border-aka/30"} px-6 transition-colors`}
            >
              <AccordionTrigger
                className={`font-body text-left text-sm md:text-base font-medium py-5 hover:no-underline ${
                  dark ? "text-shiro/90 hover:text-shiro" : "text-foreground hover:text-aka"
                } transition-colors`}
              >
                {faq.q}
              </AccordionTrigger>
              <AccordionContent
                className={`font-body text-sm leading-relaxed pb-5 ${
                  dark ? "text-shiro/60" : "text-muted-foreground"
                }`}
              >
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </section>
  );
};

export default FAQSection;
